export default __webpack_public_path__ + "static/media/aws.3ae55ef6.png";